export default __webpack_public_path__ + "static/media/Data hall.106e37b4.png";